export default {
    page_title: "Redeschidere temporara",
    filter_recently_modified: "Modificat recent",
    search_placeholder: "nume, email sau CNP",
    delete_exceptions_text: "Vrei sa stergi exceptii?",
    btn: {
        add_reopening: "Redeschidere temporara",
        delete_exceptions: "Sterge exceptii",
    },
    table: {
        beneficiary_list: "Lista beneficiari",
        beneficiary_name: "Nume",
        beneficiary_phone: "Telefon",
        beneficiary_email: "Email",
        beneficiary_cnp: "CNP",
        beneficiary_status: "Status",
        beneficiary_recently_modified: "Modificat recent",
        select_company_first: "Selecteaza mai intai o companie",
        select_company_hint: "Pentru a vedea utilizatorii, selecteaza mai intai o companie",
        no_recently_modified: 'Nu',
        recently_modified: 'Da',
        temporary_ignore_timesheet: 'Prelungire pontaj',
        status_1: 'Activ',
        status_2: 'Invitat',
        status_3: 'Suspendat',
        status_4: 'Asteapta stergerea',
    },
    modal: {
        header_text: "Ai selectat urmatorii utilizatori.",
        header_text1: "Verifica atent selectia si seteaza data pana la care platforma ramane deschisa pentru ei.",
        expiry_date_label: "Data limita de acces",
        select_date_time: "Selecteaza data",
        info_text: "Dupa aceasta data, conturile vor reveni la setarea implicita.",
        btn_reopen: "Redeschide platforma",
        ignore_timesheet_label: "Doresti redeschidere si pentru UpDejun",
        validation: {
            future_date: "Data trebuie sa fie in viitor",
            date_required: "Data este obligatorie.",
            no_user: "Te rugam sa selectezi cel putin un utilizator.",
        }
    },
    toast: {
        success_message: "Platforma a fost redeschisa cu succes pentru utilizatorii selectati!",
        error_message: "A aparut o eroare. Te rugam sa incerci din nou.",
        delete_success: "Exceptiile au fost sterse cu succes",
    },
    one_user_selected: "{count} utilizator selectat",
    few_users_selected: "{count} utilizatori selectati",
    many_users_selected: "{count} de utilizatori selectati",
    clear_selection: "Goleste selectia",
}